
export const TOP1_TOKEN = {
  address: '0xE4319B352cA79451C19D37c4728ba981aEEac9fA',
  symbol: 'TOP1',
  decimals: 18,
} as const;
